import { render, staticRenderFns } from "./NgbTeamMembersEdit.vue?vue&type=template&id=35a36972"
import script from "./NgbTeamMembersEdit.vue?vue&type=script&lang=js"
export * from "./NgbTeamMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./NgbTeamMembersEdit.vue?vue&type=style&index=0&id=35a36972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports